function removeHashFromUrl() {
    if (!window.location.hash) return;
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
}

function scheduleHashRemovalAfterScroll() {
    let settled = false;
    const run = () => {
        if (settled) return;
        settled = true;
        removeHashFromUrl();
    };

    const fallbackMs = 1000;
    const timeoutId = window.setTimeout(run, fallbackMs);

    const onScrollEnd = () => {
        window.clearTimeout(timeoutId);
        run();
    };

    document.addEventListener('scrollend', onScrollEnd, { once: true });
}

function scrollToAnchor(id: string, center?: string) {
    const section = document.getElementById(id);
    if (section) {
        scheduleHashRemovalAfterScroll();
        section.scrollIntoView({ behavior: 'smooth', block: center ? 'center' : 'start' });
    }
}
export function scrollingPageToAnchor(center?: string) {
    setTimeout(() => {
        let anchor = null;

        const hash = window.location.hash;

        if (hash) {
            anchor = hash.substring(1);
        }
        if (anchor && anchor !== null) {
            scrollToAnchor(anchor, center);
        }
    }, 10);
}
